import { render, staticRenderFns } from "./GrowthReport.vue?vue&type=template&id=dfdf765c&scoped=true&"
import script from "./GrowthReport.vue?vue&type=script&lang=js&"
export * from "./GrowthReport.vue?vue&type=script&lang=js&"
import style0 from "./GrowthReport.vue?vue&type=style&index=0&id=dfdf765c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfdf765c",
  null
  
)

export default component.exports